module.exports = __webpack_public_path__ + "img/chaxun_01.fa74ab2f.png";